import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-local-activite-form',
  templateUrl: './local-activite-form.component.html',
  styleUrls: ['./local-activite-form.component.scss'],
})
export class LocalActiviteFormComponent implements OnChanges {
  @Input() localActivite!: Report.Characteristics.LocalActivite | undefined;
  @Input() constructionYear!: number;

  @Output() localActiviteChanged =
    new EventEmitter<Report.Characteristics.LocalActivite>();

  @Output() constructionYearChanged = new EventEmitter<number>();

  localActiviteForm = new FormGroup({
    propertyType: new FormControl("Local d'activité", { nonNullable: true }),
    constructionYear: new FormControl('', [
      Validators.min(1000),
      Validators.max(9999),
      Validators.pattern(/^\d{4}$/),
    ]),
    areaM2: new FormControl(''),
    nature: new FormControl(''),
    numberOfParkingSpaces: new FormControl(''),
    publicTransportNearby: new FormGroup({
      highway_access: new FormControl(false),
      airport: new FormControl(false),
      bus: new FormControl(false),
      train_station: new FormControl(false),
      subway: new FormControl(false),
      park_and_ride: new FormControl(false),
      tramway: new FormControl(false),
    }),
  });

  transportOptions = [
    { label: 'Accès autoroute', value: 'highway_access' },
    { label: 'Aéroport', value: 'airport' },
    { label: 'Bus', value: 'bus' },
    { label: 'Gare ferroviaire', value: 'train_station' },
    { label: 'Métro', value: 'subway' },
    { label: 'Parking relais', value: 'park_and_ride' },
    { label: 'Tramway', value: 'tramway' },
  ];

  localActiviteInternal!: Report.Characteristics.LocalActivite;
  constructionYearinternal!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['localActivite'] && changes['localActivite'].currentValue) {
      this.localActiviteInternal = changes['localActivite'].currentValue;
    }

    if (
      changes['constructionYear'] &&
      changes['constructionYear'].currentValue
    ) {
      this.localActiviteForm.controls.constructionYear.setValue(
        this.constructionYear.toString(),
      );
    }

    this.setFormValues();
  }

  onConstructionYearChanged(event: Event) {
    this.constructionYearinternal = parseInt(
      (event.target as HTMLInputElement).value,
    );

    this.constructionYearChanged.emit(this.constructionYearinternal);
  }

  onAreaM2Changed(event: Event) {
    this.localActiviteInternal = {
      ...this.localActiviteInternal,
      areaM2: parseInt((event.target as HTMLInputElement).value),
    };

    this.localActiviteChanged.emit(this.localActiviteInternal);
  }

  onNatureChanged(event: Event) {
    this.localActiviteInternal = {
      ...this.localActiviteInternal,
      nature: (event.target as HTMLInputElement).value,
    };

    this.localActiviteChanged.emit(this.localActiviteInternal);
  }

  onNumberOfParkingSpacesChanged(event: Event) {
    this.localActiviteInternal = {
      ...this.localActiviteInternal,
      numberOfParkingSpaces: parseInt((event.target as HTMLInputElement).value),
    };

    this.localActiviteChanged.emit(this.localActiviteInternal);
  }

  getTransportControl(optionValue: string): FormControl {
    return this.localActiviteForm.get(
      `publicTransportNearby.${optionValue}`,
    ) as FormControl;
  }

  onTransportSelectionChanged(): void {
    const selectedOptions = this.transportOptions
      .filter((option) => this.getTransportControl(option.value).value)
      .map((option) => option.value);

    this.localActiviteInternal = {
      ...this.localActiviteInternal,
      publicTransportNearby: selectedOptions,
    };

    this.localActiviteChanged.emit(this.localActiviteInternal);
  }

  setFormValues(): void {
    this.localActiviteForm.controls.areaM2.setValue(
      this.localActiviteInternal?.areaM2?.toString(),
    );

    this.localActiviteForm.controls.nature.setValue(
      this.localActiviteInternal?.nature,
    );

    this.localActiviteForm.controls.numberOfParkingSpaces.setValue(
      this.localActiviteInternal?.numberOfParkingSpaces?.toString(),
    );

    const { publicTransportNearby } = this.localActiviteInternal;
    if (publicTransportNearby) {
      publicTransportNearby.forEach((transport) => {
        const transportOption = this.transportOptions.find((option) => {
          return option.value === transport;
        });

        if (transportOption) {
          (
            this.localActiviteForm.controls.publicTransportNearby as FormGroup
          ).controls[transportOption.value].setValue(true);
        }
      });
    }
  }
}
